var React = require('react');

function HalfCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M851.606,398.38l-54.324,62.954c17.544,14.926,44.162,12.968,59.068-4.2S869.15,413.307,851.606,398.38Z","transform":"translate(-797.282 -398.38)","fill":"currentColor","fillRule":"evenodd"}));
}

HalfCircle.defaultProps = {"width":"69","height":"73","viewBox":"0 0 69 73"};

module.exports = HalfCircle;

HalfCircle.default = HalfCircle;
